module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "overflow-ellipsis",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _c('span', {
    staticClass: "eye glyphicon glyphicon-eye-open",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.showPreview.apply(null, arguments)
      }
    }
  }), (_vm.show_preview) ? _c('template-preview', {
    attrs: {
      "template": _vm.item
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bdf945f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/autocomplete/template_item.vue
// module id = 1161
// module chunks = 1